import { styled } from "@mui/material";

/**
 * @deprecated Please use <Typography /> from @mui/material instead.
 */
const ZeroMarginP = styled("p")`
	margin: 0;
`;

/**
 * @deprecated Please use <Typography /> from @mui/material instead.
 */
export const Header1 = styled("h3")`
	font-family: ${({ theme }) => theme.typography.fontFamily};
	font-weight: 500;
	font-size: 2rem;
	margin: 0;
`;

/**
 * @deprecated Please use <Typography /> from @mui/material instead.
 */
export const Header2 = styled("h4")`
	font-family: ${({ theme }) => theme.typography.fontFamily};
	font-weight: 500;
	font-size: 1.5rem;
	margin: 0;
`;

/**
 * @deprecated Please use <Typography /> from @mui/material instead.
 */
export const Header3 = styled("h5")`
	font-family: ${({ theme }) => theme.typography.fontFamily};
	font-weight: 500;
	font-size: 1rem;
	margin: 0;
`;

/**
 * @deprecated Please use <Typography /> from @mui/material instead.
 */
export const BodyLarge = styled(ZeroMarginP)`
	font-family: ${({ theme }) => theme.typography.fontFamily};
	font-weight: 350;
	font-size: 1.5rem;
`;

/**
 * @deprecated Please use <Typography /> from @mui/material instead.
 */
export const BodyRegular = styled(ZeroMarginP)`
	font-family: ${({ theme }) => theme.typography.fontFamily};
	font-size: 1rem;
`;

/**
 * @deprecated Please use <Typography /> from @mui/material instead.
 */
export const BodyMedium = styled(ZeroMarginP)`
	font-family: ${({ theme }) => theme.typography.fontFamily};
	font-weight: 500;
	font-size: 1rem;
`;

/**
 * @deprecated Please use <Typography /> from @mui/material instead.
 */
export const BodyBook = styled(ZeroMarginP)`
	font-family: ${({ theme }) => theme.typography.fontFamily};
	font-weight: 350;
	font-size: 1rem;
`;

/**
 * @deprecated Please use <Typography /> from @mui/material instead.
 */
export const SmallRegular = styled(ZeroMarginP)`
	font-family: ${({ theme }) => theme.typography.fontFamily};
	font-size: 0.875rem;
`;

/**
 * @deprecated Please use <Typography /> from @mui/material instead.
 */
export const SmallBook = styled(ZeroMarginP)`
	font-family: ${({ theme }) => theme.typography.fontFamily};
	font-weight: 350;
	font-size: 0.875rem;
`;
